import { render, staticRenderFns } from "./CategoryEditCreate.vue?vue&type=template&id=7b15098a&"
import script from "./CategoryEditCreate.vue?vue&type=script&lang=js&"
export * from "./CategoryEditCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports